import React, { useState } from 'react';
import { Button, Typography } from '@one-thd/sui-atomic-components';
import { useActivityLogContext } from '../ActivitiyLogContext';
import Activity from './Activity';

const INITIAL_NUMBER_OF_LOGS = 3;
const ALL_LOGS_TO_SHOW = 15;

export default function List() {

  const {
    activities = [],
    updateActivity
  } = useActivityLogContext();

  const [shouldShowMoreActivity, setShowMoreActivity] = useState(false);

  const handleShowMoreActivity = () => {
    setShowMoreActivity(!shouldShowMoreActivity);
  };

  const numberOfLogsToShow = (shouldShowMoreActivity) ? ALL_LOGS_TO_SHOW : INITIAL_NUMBER_OF_LOGS;
  const visibleActivities = activities.slice(0, numberOfLogsToShow);

  return (
    <>
      <div data-component="List">
        {visibleActivities.map((element, index) => {
          return (
            <Activity
              key={index}
              activity={element}
              index={index}
              updateActivity={updateActivity}
            />
          );
        })}
      </div>
      <div className="sui-flex sui-justify-center">
        <Button
          variant="text"
          onClick={handleShowMoreActivity}
        >
          <Typography>
            {shouldShowMoreActivity ? 'Hide All Activity' : 'Show More Activity'}
          </Typography>
        </Button>
      </div>
    </>
  );
}

List.propTypes = {};

List.displayName = 'AccountActivityList';
